export default __webpack_public_path__ + "static/media/iphoneseven.df57a100.png";